<template>
  <div :class="$style.filter_save">
    <filter-header
      ref="header"
      :title="locales('filter_saving_view')"
      :help-icon="false"
      :back-icon="true"
      :component-name="componentName"
      @closeClick="$emit('onClose')"
      @backClick="$emit('backClick')"
    />
    <div
      :class="$style.body"
      :style="{height: height}"
    >
      <div :class="$style.filter_name">
        <vgp-label-slot :label="locales('filter_saving_view_new_name')">
          <template #body>
            <div :class="$style.input">
              <vgp-input
                ref="input"
                v-model="filterName"
                :is-error="isNameError"
                :model-value="filterName"
                :placeholder="locales('filter_saving_view_new_name')"
                :small="true"
                @update:modelValue="onInput"
              />
            </div>
          </template>
        </vgp-label-slot>
      </div>
      <div
        ref="scroll"
        :class="[$style.filter_settings, 'gantt_scroll']"
      >
        <div
          v-for="(item, index) in filter.staticFilterItems"
          :key="index"
        >
          <filter-item
            v-if="hasValues(item.property)"
            :class="[$style.filter_item, $style.slot_item]"
            :label="item.label"
            :filter-item="item"
            :readonly="true"
          />
        </div>
        <div
          v-for="(item, index) in preparedCustomColumns"
          :key="index"
          :class="$style.filter_item"
        >
          <div
            v-if="item.columnsTitle"
            :class="$style.columns_title"
          >
            <div :class="$style.text">
              {{ item.columnsTitle }}
            </div>
            <div :class="$style.line" />
          </div>
          <filter-item
            v-else
            :class="$style.slot_item"
            :label="item.label"
            :filter-item="item"
            :readonly="true"
            @changeFilter="changeCustomFieldsFilter"
          />
        </div>
      </div>
      <gradient :show="isShowGradient" />
    </div>
    <filter-footers
      ref="footers"
      :footer-type="'footer-save'"
      @onApplyClick="onApplySaving"
      @onCancelClick="$emit('backClick')"
    />
  </div>
</template>

<script>
import filterHeader from '../components/filterHeader.vue';
import filterItem from '../components/filterItem.vue';
import filterFooters from '../components/filterFooters.vue';
import gradient from '../components/gradient.vue';
import vgpLabelSlot from '../../common/VueComponents/label/vgpLabelSlot.vue';
import vgpInput from '../../common/VueComponents/vInput/vgpInput.vue';
import filterConstants from '../constants';

export default {
  components: {
    filterHeader, filterItem, filterFooters, gradient, vgpLabelSlot, vgpInput,
  },
  props: {
    filter: { type: Object, required: true, default: () => {} },
    componentName: { type: String, required: true, default: '' },
  },
  emits: {
    backClick: null,
    onClose: null,
    onSave: Object,
  },
  data() {
    return {
      locales: __,
      height: 0,
      filterName: '',
      isNameError: false,
      isShowGradient: true,
    };
  },
  computed: {
    preparedCustomColumns() {
      let items = [];

      if (this.filter.properties.customColumns && this.filter.customColumnsItems?.length) {
        const filteredItemsWithValues = this.filter.customColumnsItems.filter(item => this.hasCustomColumnsValues(item.property));

        if (filteredItemsWithValues.length) {
          items = [{ columnsTitle: __('filter_custom_columns_title') }].concat(filteredItemsWithValues);
        }
      }

      return items;
    },
  },
  mounted() {
    const element = this.$refs.scroll;

    element.addEventListener('wheel', this.onScroll);
    this.calcHeight();
    setTimeout(() => {
      const input = this.$refs.input;

      input.focusElement();
    }, 0);
  },
  beforeUnmount() {
    const element = this.$refs.scroll;

    element.removeEventListener('wheel', this.onScroll);
  },
  created() {
    if (this.filter && this.filter.name?.length) {
      this.filterName = this.filter.name;
      this.isNameError = false;
    }
  },
  methods: {
    hasValues(prop) {
      let hasValues = false;
      const value = this.filter.properties[prop];
      const isOverdue = filterConstants.PROPERTY.overdue === prop;
      const isOverdueEnabled = isOverdue && value;
      const enabledValue = value?.length || Object.keys(value)?.length;

      if (enabledValue || isOverdueEnabled) {
        hasValues = true;
      }

      return hasValues;
    },
    hasCustomColumnsValues(prop) {
      let hasValues = false;

      if (!this.filter.properties.customColumns) {
        return false;
      }

      const value = this.filter.properties.customColumns[prop];

      if (value && value !== '') {
        hasValues = true;
      }

      return hasValues;
    },
    onScroll() {
      const element = this.$refs.scroll;
      const scrollTop = element.scrollTop;
      const scrollHeight = element.scrollHeight;
      const clientHeight = element.clientHeight;

      if (scrollTop + clientHeight >= scrollHeight) {
        this.isShowGradient = false;
      } else {
        this.isShowGradient = true;
      }
    },
    calcHeight() {
      const header = this.$refs.header.$el;
      const footer = this.$refs.footers.$el;
      const appHeader = document.documentElement.querySelector('#header');
      const currentHeader = appHeader ? appHeader.clientHeight : 94;
      // const appFooter = 0;
      const diff = header.clientHeight + footer.clientHeight + currentHeader;

      this.height = `calc(100vh - ${diff}px)`;
    },
    onInput(val) {
      this.isNameError = false;
      this.filterName = val.trim();
    },
    onApplySaving() {
      if (this.filterName === '') {
        this.isNameError = true;

        return;
      }

      this.$emit('onSave', {
        id: this.filter.id,
        name: this.filterName,
      });
      this.filterName = '';
    },
  },
};
</script>

<style module lang='less'>
@import '../../../less/_mixins.less';
@import '../../../less/_fonts.less';

.filter_save {
  .body {
    position: relative;
    padding: 0 12px;

    .filter_name {
      padding: 24px 0;
    }

    .filter_settings {
      height: calc(100% - 110px);
      padding: 0 1px;

      .filter_item {
        margin-bottom: 8px;

        .columns_title {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 7px 0;

          .text {
            white-space: nowrap;
            text-transform: uppercase;
            .FontLatoRegular;
            .fs(12px, 18px);
            color: #999999;
            margin-right: 8px;
          }

          .line {
            height: 1px;
            width: 100%;
            background: #e5e5e5;
          }
        }
      }

      .slot_item {
        & > div {
          margin: 0;
        }
      }
    }
  }
}
</style>
